import { useCallback, useEffect, useState } from 'react'

import { useWindowResize } from '@utils/domUtils'

export const useCollapsibleFilters = () => {
  const isMobile = useWindowResize()
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    setExpanded(false)
  }, [isMobile])

  const toggle = useCallback(() => {
    setExpanded((prev) => !prev)
  }, [])

  return {
    filtersVisible: !isMobile || expanded,
    onFilterToggle: isMobile ? toggle : undefined,
  }
}
